import { createFileRoute } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { TenantDetailPage } from '@/pages/admin/tenants/TenantDetailPage';
import { tenantKeys } from '@/pages/admin/api/queries/useTenants';
import { apiClient } from '@/api/client';
import { notFoundOrUnknownKey } from '@/api/errors';
import { listTenantsContract, type ListTenantsResponse } from '@bliks-io/contracts';
import i18next from '@/lib/i18n';

export const Route = createFileRoute('/admin/tenants/$tenantId/')({
  loader: async ({
    params,
    context
  }: {
    params: { tenantId: string };
    context: { queryClient: QueryClient };
  }) => {
    try {
      const tenantsData = await context.queryClient.ensureQueryData({
        queryKey: tenantKeys.list(),
        queryFn: async (): Promise<ListTenantsResponse> => {
          const { data } = await apiClient.get<ListTenantsResponse>(listTenantsContract.path);
          return data;
        }
      });

      const tenant = tenantsData.tenants.find((t) => t._id === params.tenantId);

      return { breadcrumb: tenant?.name ?? i18next.t('errors.tenant.notFound') };
    } catch (error) {
      return { breadcrumb: i18next.t(notFoundOrUnknownKey(error, 'errors.tenant.notFound')) };
    }
  },
  component: TenantDetailPage
});
